// extracted by mini-css-extract-plugin
module.exports = {"element":"ListElement_element__3ufq6","blue":"ListElement_blue__2q2eX","red":"ListElement_red__3LprD"};